import { Outlet } from 'react-router';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';

import Header from './Header';
import Footer from './Footer';

export default function Layout() {
  return (
    <Container maxWidth="xl">
      <CssBaseline />
      <Header />
      <Container maxWidth="xl">
        <Outlet />
      </Container>
      <Footer />
    </Container>
  );
}
